import { css } from 'react-emotion';

import { flex } from 'appStyles';

export const container = css`
  position: relative;
`;

export const dealRow = css`
  width: 45rem;
  border: 1px solid rgba(200,200,200,.4);
  padding: 1rem;
  margin: 2rem;
`;

export const dealButton = css`
  ${flex};
  margin: 2rem;
  position: relative;
  padding: .4rem;
  background: white;
  border: 2px solid rgba(100,100,100,1);
  border-radius: .4rem;
  color: black;
  width: 10rem;
  cursor: pointer;
`;

export const textArea = css`
  margin-top: 3rem;
  resize: none;
  width: 40rem;
  min-height: 7rem;
  background: none;
  color: white;
  font-size: 1.5rem;
  outline: none;
  box-shadow: none;
  border: 1px solid rgba(100,180,200,.7);
  padding: 1rem;
  transition: .4s;

  &:hover {
    border-color: aqua;
    transition: 1s;
  }
`;

